<div class="denuncias-entry">
  <section class="denuncias-entry__hero">
    <div class="denuncias-entry__hero-inner">
      <div class="denuncias-entry__eyebrow">SOLSER · ARQUITECTURA DE CONFIANZA</div>

      <h1 class="denuncias-entry__title">
        Bienvenido, tu participación es muy importante para SOLSER
      </h1>

      <p class="denuncias-entry__lead">
        Hemos diseñado este espacio bajo una filosofía de <strong>Serenidad Arquitectónica</strong>.
        Un entorno seguro, privado e inalterable donde tu voz es protegida con los más altos
        estándares de confidencialidad.
      </p>

      <div class="denuncias-entry__actions">
        <a class="denuncias-entry__button denuncias-entry__button--primary" routerLink="/denuncia/nuevo-reporte">
          <span>Iniciar nuevo reporte</span>
          <span aria-hidden="true">→</span>
        </a>

        <a class="denuncias-entry__button denuncias-entry__button--secondary" routerLink="/denuncia/confirmacion">
          Consultar estado de mi denuncia
        </a>
      </div>
    </div>
  </section>

  <section class="denuncias-entry__trust-band" id="confianza">
    <div class="denuncias-entry__band-inner">
      <article class="denuncias-entry__panel denuncias-entry__panel--light">
        <h2>¿Por qué denunciar?</h2>
        <p>
          El Canal de Denuncias es una herramienta esencial para mantener la integridad de
          nuestra organización. Permite reportar comportamientos irregulares, éticos o legales
          de manera segura.
        </p>

        <div class="denuncias-entry__pillars">
          <div class="denuncias-entry__pillar">
            <span class="denuncias-entry__pillar-icon denuncias-entry__pillar-icon--shield"></span>
            <strong>Protección Total</strong>
            <p>Garantizamos la inmunidad del denunciante de buena fe.</p>
          </div>

          <div class="denuncias-entry__pillar">
            <span class="denuncias-entry__pillar-icon denuncias-entry__pillar-icon--lock"></span>
            <strong>Cifrado de Extremo</strong>
            <p>Sus datos están encriptados bajo protocolos bancarios.</p>
          </div>

          <div class="denuncias-entry__pillar">
            <span class="denuncias-entry__pillar-icon denuncias-entry__pillar-icon--privacy"></span>
            <strong>Anonimato Real</strong>
            <p>No rastreamos direcciones IP ni metadatos de archivos.</p>
          </div>
        </div>
      </article>

      <article class="denuncias-entry__panel denuncias-entry__panel--dark">
        <div class="denuncias-entry__legal-mark" aria-hidden="true">
          <span></span>
          <span></span>
          <span></span>
        </div>

        <h2>Marco Legal</h2>
        <p>
          Operamos bajo el cumplimiento estricto de la Ley de Protección al Denunciante y
          normativas internacionales de Compliance.
        </p>

        <!-- <a class="denuncias-entry__legal-link" href="#confianza">
          Ver principios de confidencialidad
        </a> -->
      </article>
    </div>
  </section>
</div>